module.exports = __webpack_public_path__ + "img/ic-reply.a3b8de64.svg";